export const SET_PROMOTION = 'SET_PROMOTION';
export const RESET_PROMOTION = 'RESET_PROMOTION';



// WEBPACK FOOTER //
// ./src/store/reducers/promotions/actionTypes.js